<template>
  <div class="p-create-success g-f-c">
    <div>
      <img src="./images/create_success.png" alt="">
      <p class="mt-16">测评创建成功~</p>
      <footer class="mt-40">
        <el-button type="primary" plain @click="onBackClick">返回测评中心 {{countdown}}</el-button>
        <el-button type="primary" @click="onRecreateClick">再创建一个</el-button>
      </footer>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CreateTestSuccess',
  data() {
    return {
      timerId: null,
      countdown: 5,
    };
  },
  methods: {
    onBackClick() {
      this.$router.replace({
        path: '/pt/test-center',
      });
    },
    onRecreateClick() {
      this.$router.push({
        path: '/pt/create-test',
      });
    },
    onCreateClick() {
      this.$router.replace({
        path: '/pt/create-test',
      });
    },
    start() {
      this.timerId = setInterval(() => {
        this.countdown -= 1;
        if (this.countdown === 0) {
          this.onBackClick();
        }
      }, 1000);
    },
    reset() {
      clearInterval(this.timerId);
      this.countdown = 5;
    },
  },
  activated() {
    this.start();
  },
  deactivated() {
    this.reset();
  },
};
</script>

<style lang="scss" scoped>
.p-create-success {
  padding: 32px 32px 100px;
  height: 100%;
  box-sizing: border-box;
  overflow-y: auto;
  background: #fff;
  position: relative;
  color: rgba(0, 0, 0, 0.6);
  font-size: 18px;
  text-align: center;
  font-weight: 500;
  img {
    display: block;
    width: 233px;
    margin: 0 auto;
  }
}
</style>
